import { useNavigate, useSearchParams } from "react-router-dom";

import { Button } from "../../components/Button";
import { t } from "../../i18n/t";
import { ReturnPage } from "./ReturnPage";

/**
 * Critique addendum C4: `complete_hmrc_consent` redirects to `{web_base_url}/oauth/hmrc/return?connection=
 * …&migration=…`, and until this route existed the round trip ended on a 404 page — pre-existing for a
 * first attach, but now on the re-run's own critical path (V4's "Reconnect HMRC" link). A minimal
 * confirmation only: "HMRC connected", and a link back to `/migrations/:id` (`StageRedirect` sends the
 * operator to whichever screen owns the migration's current state), or to `/` when `migration` is absent.
 * Redrawn in the XeroOrg.html chrome the handoff assigns to both return routes.
 */
export function HmrcReturn(): JSX.Element {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const migrationId = params.get("migration");

  return (
    <ReturnPage sourceSystem="hmrc" title={t("hmrc_return.title")}>
      <p>{t("hmrc_return.connected")}</p>
      <div className="formactions formactions--start">
        <Button onClick={() => navigate(migrationId === null ? "/" : `/migrations/${migrationId}`)}>
          {migrationId === null ? t("hmrc_return.home") : t("hmrc_return.back_to_migration")}
        </Button>
      </div>
    </ReturnPage>
  );
}
